/**
 * EINE Definition der Shared-Device-Session (Stempel-Terminal).
 *
 * Historie: #1786 haengte den erzwungenen Hell-Modus an den HOST. #1809 hat das
 * auf die SESSION umgestellt und den JWT-Claim `pin_login` zur Wahrheit gemacht.
 * Das war zu wenig: `pin_login` markiert die Login-METHODE, nicht das GERAET —
 * auf work.weship.eu fuehrt jeder Weg durch den PIN-Schirm, also galt dort jede
 * Sitzung als Kiosk und der Dark-Mode-Schalter verschwand fuer alle.
 *
 * Wahrheit ist deshalb seit dem #1809-Fix das REGISTRIERTE GERAET: Terminals
 * werden einmalig gekoppelt und tragen einen serverseitig ausgestellten
 * Device-Token. Der Server bestaetigt ihn pro Anfrage als `user.kiosk_device`.
 *
 * FAIL-DIRECTION: Ohne Registrierung ist ein Geraet NICHT Kiosk. Ein privates
 * Handy, ein neues Tablet und ein widerrufenes Terminal verhalten sich alle
 * persoenlich (Dark Mode, Slider, Sprachwahl) — eine fehlende Registrierung
 * sperrt niemanden aus, sie aendert nur die Darstellung.
 */
import { getGeraetToken } from './kioskDevice';

export function istKioskSession(user) {
  // Steht eine Sitzung, entscheidet ALLEIN die Server-Antwort. Der lokale Token
  // taugt dann nicht mehr als Zeuge: er koennte laengst widerrufen sein.
  if (user) return user.kiosk_device === true;
  // Vor der Sitzung (PIN-Schirm, erster Paint): der lokal hinterlegte Token ist
  // das einzige synchron Lesbare. Er entscheidet hier nur ueber die Optik.
  return !!getGeraetToken();
}
